import React, { useState } from 'react';
import "./AboutUsStyles.css";

const About = () => {
    const [activeTab, setActiveTab] = useState("history");

    return (
        <div className="content">
            <h3 className="heading"> About Us</h3>
            <div className='tabs'>
                <ul className='nav'>
                    <TabNavItem title="About Us" id="history" activeTab={activeTab} setActiveTab={setActiveTab} />
                    <TabNavItem title="Mission & Vision" id="mission" activeTab={activeTab} setActiveTab={setActiveTab} />
                    {/* <TabNavItem title="Core Functions" id="functions" activeTab={activeTab} setActiveTab={setActiveTab} /> */}
                    <TabNavItem title="Board of Directors" id="board" activeTab={activeTab} setActiveTab={setActiveTab} />
                    {/* <TabNavItem title="Our Shareholders" id="shareholders" activeTab={activeTab} setActiveTab={setActiveTab} /> */}
                    {/* <TabNavItem title="Our Subsidiaries" id="subsidiaries" activeTab={activeTab} setActiveTab={setActiveTab} /> */}
                    {/* <TabNavItem title="Operating Structure" id="structure" activeTab={activeTab} setActiveTab={setActiveTab} /> */}
                    <TabNavItem title="Track Record" id="record" activeTab={activeTab} setActiveTab={setActiveTab} />
                </ul>
                <div className='outlet'>
                    <TabContent id="history" activeTab={activeTab}>
                        <History />
                    </TabContent>
                    <TabContent id="mission" activeTab={activeTab}>
                        <MissionVisionValues />
                    </TabContent>
                    <TabContent id="functions" activeTab={activeTab}>
                        <Functions />
                    </TabContent>
                    <TabContent id="board" activeTab={activeTab}>
                        <Board />
                    </TabContent>
                    <TabContent id="shareholders" activeTab={activeTab}>
                        <Shareholders />
                    </TabContent>
                    <TabContent id="subsidiaries" activeTab={activeTab}>
                        <Subsidiaries />
                    </TabContent>
                    <TabContent id="structure" activeTab={activeTab}>
                        <OperatingStructure />
                    </TabContent>
                    <TabContent id="record" activeTab={activeTab}>
                        <TrackRecord />
                    </TabContent>

                </div>
            </div>
        </div>
    )
}
export default About

function TabNavItem({ id, title, activeTab, setActiveTab }) {
    const handleClick = () => {
        setActiveTab(id);
    };
    return (
        <li onClick={handleClick} className={activeTab === id ? "active" : ""}>
            {title}
        </li>
    )
}
function TabContent({ id, activeTab, children }) {
    return (
        activeTab === id ? <div className='TabContent'>
            {children}
        </div>
            : null
    )
}

function History() {
    return (
        <div className='history'>
            <h1>Who We Are</h1>
            <p>The Company, NTHC Commodities Limited is a 100% Ghanaian owned private limited Liability Company registered under the company’s code of 1963 (Act 179) in Accra on 12th January 2012 and authorized to commence business on the 13th day of January 2012 with Registration No. CA-97,686. NTHC Commodities   Limited is licensed with Ghana Cocoa Board as a licensed buying Company (LBC) with license number GCB/CCL/056/13 in fulfillment of the regulatory requirement to participate in the internal marketing of cocoa in Ghana.</p><br />
            <p>The privatization of the cocoa industry in Ghana started in the early 1990’s with the licensing of private companies to purchase cocoa from farmers for onward delivery to Cocoa Marketing Company Limited (CMC) of Cocobod for a fee.</p><br />
            <p>The Company was able to purchase 5,325 metric tonnes of cocoa beans and delivered to Ghana Cocoa Board using only internal funding in the first year of operation (2013/2014) crop year. This achievement qualified the company for the Cocobod seed fund to the tune of 26 million Ghana Cedis to support the company’s purchases. To qualify for Cocobod seed fund, a company needs to purchase 500 metric tonnes in its first year of operation. Currently, the company operates a hybrid of the external franchise system and internal funding systems. The franchise system has been properly structured to produce a responsive and efficient purchasing organization.</p><br />

            <h1>Our Mission</h1>
            <p>We seek to provide the best conditioned cocoa to the Cocoa Marketing Company in a prompt and timely manner whiles ensuring utmost efficiency and having regards for environmental sustainability.</p><br />

            <h1>Our Vision</h1>
            <p>NTHC Commodities Ltd aims to be the leading company and the farmer’s first choice in commodities trading and all allied business.</p><br />

            <h1>Our Values </h1>
            <ul>
                <li>
                    <p>
                        <strong>Sustainability of the Environment :</strong> We ensure that all our activities are undertaken in a sustainable manner to protect the environment.
                    </p>
                </li>
                <li>
                    <p>
                        <strong>Integrity :</strong> We always maintain integrity in all our operations.
                    </p>
                </li>
                <li>
                    <p>
                        <strong>People Focus :</strong> People are at the center of everything we do.
                    </p>
                </li>
                <li>
                    <p>
                        <strong>Passion :</strong>  We cultivate a culture of excellence and discharge our duties with passion.
                    </p>
                </li>
            </ul>

        </div>
    )
}
function MissionVisionValues() {
    return (
        <div className='mission'>
            <h1>Our Mission</h1>
            <p>We seek to provide the best conditioned cocoa to the Cocoa Marketing Company in a prompt and timely manner whiles ensuring utmost efficiency and having regards for environmental sustainability.</p><br />

            <h1>Our Vision</h1>
            <p>NTHC Commodities Ltd aims to be the leading company and the farmer’s first choice in commodities trading and all allied business.</p><br />

            <h1>Our Values </h1>
            <ul>
                <li>
                    <p>
                        <strong>Sustainability of the Environment :</strong> We ensure that all our activities are undertaken in a sustainable manner to protect the environment.
                    </p>
                </li>
                <li>
                    <p>
                        <strong>Integrity :</strong> We always maintain integrity in all our operations.
                    </p>
                </li>
                <li>
                    <p>
                        <strong>People Focus :</strong> People are at the center of everything we do.
                    </p>
                </li>
                <li>
                    <p>
                        <strong>Passion :</strong>  We cultivate a culture of excellence and discharge our duties with passion.
                    </p>
                </li>
            </ul>
        </div>
    )
}

function Functions() {
    return (
        <div className='core-functions'>
            <h1>Core Functions</h1>
            <p>We have strategic business units through which we undertake specific business activities within the varied sectors of the economy.</p>
            <p>These strategic business units are incorporated as subsidiary companies to provide diversity of investments opportunities.</p>
            <p> The core functions of the strategic business units are the following:</p>
            <ul>
                <li>
                    <p>Corporate Finance Advisory</p>
                </li>
                <li>
                    <p>Asset Management Business</p>
                </li>
                <li>
                    <p>Securities Trading</p>
                </li>
                <li>
                    <p>Shares Registrar & Company Secretarial Business</p>
                </li>
                <li>
                    <p>Pensions Trustees Business</p>
                </li>
                <li>
                    <p>Commodities Trading Business</p>
                </li>
                <li>
                    <p>Real Estates Business</p>
                </li>
            </ul>
        </div>
    )
}
function Board() {
    return (
        <div className='board-composition'>
            <h1>Board of Directors</h1>
            <p> The Board of Directors are responsible for the policy direction of the company.</p>
            <div className='sub-board'>
                <div className="sub-board-card">
                    <div className='sub-board-image'>
                        <img alt='boardImg' src="/images/board/Kofi_Agyeman_Boakye.png" />
                    </div>
                    <h3>Kofi-AgyemanBoakye</h3>
                    <h4>Board Chairman</h4>
                </div>
                <div className="sub-board-card">
                    <div className='sub-board-image'>
                        <img alt='boardImg' src="/images/board/Isaac_Charles_Acquah.png" />
                    </div>
                    <h3>Isaac Charles Acquah</h3>
                    <h4> Board Member</h4>
                </div>
                <div className="sub-board-card">
                    <div className='sub-board-image'>
                        <img alt='boardImg' src="/images/board/.png" />
                    </div>
                    <h3>Mr. Ernest Abassah (Pic)</h3>
                    <h4>Board Member</h4>
                </div>
                <div className="sub-board-card">
                    <div className='sub-board-image'>
                        <img alt='boardImg' src="/images/board/Thomas_Osei_Antwi.png" />
                    </div>
                    <h3>Mr. Thomas Antwi-Osei</h3>
                    <h4>Board Member</h4>
                </div>
            </div>
        </div>
    )
}
function Shareholders() {
    return (
        <div className='shareholders'>
            <h1> Our Shareholders</h1>
            <div className="shareholders-card">
                <div className="holders-card">
                    <div className="col-md-2 logo-image">
                        <figure>
                            <img src="/images/shareholders/ssnit_logo.jpg" alt="SSNIT Logo" width="512" height="512" />
                        </figure>
                    </div>
                    <div>
                        <div><h3>Social Security and National Insurance Trust (SSNIT)</h3></div>

                        <div><p>The Social Security and National Insurance Trust (SSNIT), established in 1972, is a statutory public Trust
                            charged under the National Pensions Act 2008 Act 766 with the administration of Ghana’s Basic National
                            Social Security Pension Scheme and to cater for the first tier of the contributory three-tier scheme. Today
                            it manages one of the largest asset portfolios in Ghana. SSNIT currently holds <strong>75%</strong> shareholding in NTHC Limited.</p></div>
                    </div>
                </div>
                <div className="holders-card">
                    <div className="col-md-2 logo-image">
                        <figure>
                            <img src="/images/shareholders/nib.png" alt="NIB Logo" width="512" height="512" />
                        </figure>
                    </div>
                    <div>
                        <div><h3>Investment Bank (NIB)</h3></div>
                        <div>
                            <p>National Investment Bank (NIB), was incorporated in 1963 as an autonomous joint state-private institution
                                primarily to promote and strengthen rapid industrialization in all sectors of the Ghanaian economy. Today it
                                is one of the oldest established banks in the country. NIB currently holds <strong>8.71%</strong>
                                shareholding in NTHC Limited.</p>
                        </div>
                    </div>
                </div>
                <div className="holders-card">
                    <div className="col-md-2 logo-image">
                        <figure>
                            <img src="/images/shareholders/sic_logo.png" alt="SIC Logo" width="512" height="512" />
                        </figure>
                    </div>
                    <div>
                        <div><h3>Insurance Company Limited (SIC)</h3></div>
                        <div>
                            <p>State Insurance Company Limited (SIC) traces its roots to 1955. It is the nation’s largest insurer and
                                the
                                only one with a nationwide coverage. The Company has consistently maintained a steady market leadership
                                and
                                currently holds considerable market share in both the general and life insurance business. SIC currently
                                holds <strong>8.71%</strong> shareholding in NTHC Limited.</p>
                        </div>
                    </div>
                </div>



                <h3>AcreCon Limited</h3>
                <div className="col-md-2 logo-image">
                    <figure>
                        <img src="/images/shareholders/acrecon_logo.png" alt="ACRECON Logo" width="512" height="512" />
                    </figure>
                </div>
                <p>Acrecon Limited is a private Ghanaian company providing investment advisory and financial consultancy
                    services.
                    AcreCon Limited currently holds <strong>5.45%</strong> shareholding in NTHC Limited.</p>


                <h3>NTHC Provident Fund</h3>
                <div className="col-md-2 logo-image">
                    <figure>
                        <img src="/images/shareholders/pf_logo.png" alt="PF Logo" width="512" height="512" />
                    </figure>
                </div>
                <p>Staff of NTHC Group got the opportunity to own part of the Company in February 2001, through the staff
                    Provident Fund.
                    NTHC Provident Fund currently holds <strong>2.09%</strong> shareholding in NTHC Limited.</p>
            </div>
        </div>
    )
}
function Subsidiaries() {
    return (
        <div className='our-subsidiaries'>
            <h1>NTHC Group</h1>
            <p>NTHC Group is made up NTHC Limited and six(6) subsidiary companies.</p>
            <p><h3>Subsidiaries</h3></p>
            <ol type="1">
                <li>
                    <p>NTHC Asset Management Limited</p>
                </li>

                <li>
                    <p>NTHC Trustees Limited</p>
                </li>

                <li>
                    <p>NTHC Registrar Limited</p>
                </li>

                <li>
                    <p>NTHC Securities Limited</p>
                </li>

                <li>
                    <p>NTHC Commodities Limited</p>
                </li>

                <li>
                    <p>NTHC Properties Limited</p>
                </li>
            </ol>
        </div>
    )
}
function OperatingStructure() {
    return (
        <div className='operating-structure'>
            <h1> Operating Structure</h1>
            <p>NTHC Group comprises the holding Company NTHC Limited and six wholly-owned subsidiaries. The Group is
                managed at the Holding Company level by a Board of Directors with representation from Institutional
                Shareholders.
            </p>
            <p>
                Each Subsidiary is managed by a Board of Directors made up of independent, non executive and executive
                directors.
            </p>

            <p>
                <figure class="opt-img">
                    <img src="/images/nthc_group.jpg" alt="SIC Logo" width="1195" height="860" />
                </figure>
            </p>

        </div>
    )
}
function TrackRecord() {
    return (
        <div className='track-record'>
            <h1>Our Track Record</h1>
            <p>The Company was able to purchase 5,325 metric tonnes of cocoa beans and delivered to Ghana Cocoa Board using only internal funding in the first year of operation (2013/2014) crop year.</p >
                <p>This achievement qualified the company for the Cocobod seed fund to the tune of 26 million Ghana Cedis to support the company’s purchases.</p>
                <p>To qualify for Cocobod seed fund, a company needs to purchase 500 metric tonnes in its first year of operation.</p>
                <p>Currently, the company operates a hybrid of the external franchise system and internal funding systems. The franchise system has been properly structured to produce a responsive and efficient purchasing organization.</p>
        </div>
    )
}

